var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1282,
    height: 1024,
    viewBox: "0 0 1282 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00005 0L1 1024M92.4286 0L92.4285 1024M183.857 0L183.857 1024M275.286 0L275.286 1024M366.714 0L366.714 1024M458.143 0L458.143 1024M549.571 0V1024M641 0L641 1024M732.428 0V1024M823.857 0L823.857 1024M915.286 0V1024M1006.71 0V1024M1098.14 0V1024M1189.57 0V1024M1281 0V1024",
    stroke: "url(#paint0_linear_1475_5699)",
    strokeOpacity: 0.16
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1475_5699",
    x1: 641,
    y1: 0,
    x2: 641,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717784",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.2913ef1aa9f9a3d7b9857e3318e3b642.svg";
export { ForwardRef as ReactComponent };